import {
  ApiResponse,
  BookingDetailsType,
  BookingsListParams,
  BookingsType,
  GridResponse,
} from '../../types/types';
import { client } from '../client';
import { urls } from '../endpoints';

export const getAllBookings = async (params?: BookingsListParams) => {
  try {
    const response = await client.get<
      ApiResponse<GridResponse<BookingsType[]>>
    >(urls.bookings(params));

    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    return null;
  }
};

export const cancelBooking = async (Ids: {
  bookingId: number;
  updatedBy: number;
}) => {
  try {
    const response = await client.post(urls.cancelBooking(Ids.bookingId), {
      ...Ids,
      cancellationReason: 'Change of plans',
    });

    return response.data;
  } catch (error) {
    console.error('Error cancelling booking');
    throw error;
  }
};

export const getBookingDetailsRequest = async (bookingId: number) => {
  try {
    const response = await client.get<ApiResponse<BookingDetailsType>>(
      urls.getBookingDetails(bookingId),
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.log('Error fetching booking details');
  }
};

export const cancelBookingSlot = async (Ids: {
  bookingId: number;
  slotId: number;
}) => {
  try {
    const response = await client.post(
      urls.cancelBookingSlot(Ids.bookingId, Ids.slotId),
    );
    return response.data;
  } catch (error) {
    console.error('Error cancelling booking');
    throw error;
  }
};
